import { Badge } from '@/components/ui/badge';
import type { MediaAvailability } from '../types';

const availabilityConfig: Record<MediaAvailability, { label: string; className: string }> = {
  available: { label: 'Available', className: 'bg-green-50 text-green-700 border-green-200' },
  in_campaign: { label: 'In Campaign', className: 'bg-blue-50 text-blue-700 border-blue-200' },
  reserved: { label: 'Reserved', className: 'bg-purple-50 text-purple-700 border-purple-200' },
  unavailable: { label: 'Unavailable', className: 'bg-gray-50 text-gray-600 border-gray-200' },
  damaged: { label: 'Damaged', className: 'bg-red-50 text-red-700 border-red-200' },
};

interface MediaAvailabilityBadgeProps {
  availability: MediaAvailability;
}

export function MediaAvailabilityBadge({ availability }: MediaAvailabilityBadgeProps) {
  const config = availabilityConfig[availability];
  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
}
